import React from "react";
import "./hotspotModal.css";
import imgNotFound from "../../assets/img-not-found.png";
import playIcon from "../../assets/play-icon.png";
import { BaseUrl } from "../../config.js";
import { LazyLoadImage } from "react-lazy-load-image-component";

const HotspotModal = ({
  onModelClose,
  modalCloseIcon,
  hotspotContent,
  longDesc,
  setLongDesc,
  showMoreIcon,
  hotspotBaseUrl,
  onVidelModel,
}) => {
  return (
    <>
      <div data-hotspot-title={hotspotContent[0]?.Name}
        style={{
          backgroundColor: "#eeeeee",
          border: "1px solid #B6B6B6",
          borderRadius: "0px 0px 0px 0px",
          width: "20rem",
          maxHeight: "100%",
          position: "absolute",
          top: "0rem",
          right: "0rem",
          zIndex: "1",
          overflow: "scroll",
          overflowY: "scroll",
        }}
      >
        <h1
          className="hotspot-title mediumFont"
          data-hotspot-title={hotspotContent[0]?.Name}
        >
          {hotspotContent[0]?.Name}
        </h1>
        {longDesc ? (
          <>
            {hotspotContent[0]?.Description.map((item, key) => (
              <>
                {item.Name === "DescriptionText" && (
                  <div className="hotspot-desc mediumFont">{item.Meta}</div>
                )}
                {item.Name === "DescriptionImage" && (
                  <div>
                    <LazyLoadImage
                      src={BaseUrl() + item.Path}
                      PlaceholderSrc={imgNotFound}
                      alt="desc"
                      className="hotspot-img"
                    />
                  </div>

                  //  <img
                  //     className="hotspot-img"
                  //     src={item.Path ? BaseUrl() + item.Path : imgNotFound}
                  //     alt="desc"
                  //   />
                )}

                {item.Name === "DescriptionVideo" && (
                  <div className="hotspot-video">
                    <div className="poster-container">
                      <img src={BaseUrl() + item.Meta} className="poster-img" />
                      <img
                        src={playIcon}
                        className="poster-play-icon"
                        onClick={() => {
                          onVidelModel(
                            BaseUrl() + item.Meta,
                            BaseUrl() + item.Path
                          );
                        }}
                      />
                    </div>
                  </div>
                )}
              </>
            ))}
          </>
        ) : (
          <>
            <div className="hotspot-desc-text mediumFont">
              {hotspotContent[0]?.Description[0]?.Meta}
            </div>
            <div onClick={() => setLongDesc()}>
              <img className="showmore" src={showMoreIcon} alt="more" />
            </div>
          </>
        )}
      </div>
      <div className="cross-icon-image" onClick={() => onModelClose()}>
        <img src={modalCloseIcon} alt="close" />
      </div>
    </>
  );
};

export default HotspotModal;
